module.exports = __webpack_public_path__ + "static/media/archive-bg@2x.789bb1b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/archive-bg@2x.png
// module id = 927
// module chunks = 0